import { Auth } from '@angular/fire/auth';
import { createApi } from '@core/api/base-api';
import type { AlaCarteMenu, AlaCarteContent } from '@core/interfaces/api';

export const createAlaCarteApi = (auth: Auth) => {
  const api = createApi(auth);
  return {
    listForSite: (siteId: number) =>
      api.get<AlaCarteMenu[]>(`/alacarte/site/${siteId}`),

    create: (data: { siteId: number; title: string; content: AlaCarteContent }) =>
      api.post<AlaCarteMenu>('/alacarte', data),

    update: (id: number, data: Partial<{ title: string; content: AlaCarteContent }>) =>
      api.patch<AlaCarteMenu>(`/alacarte/${id}`, data),

    remove: (id: number) =>
      api.delete<void>(`/alacarte/${id}`),
  };
};
